<template>
    <v-row no-gutters>
        <v-col cols="12" md="7" class="pe-1">
            <v-autocomplete
                label="Item"
                v-model="line.item_id"
                :items="items"
                item-text="display_name"
                item-value="id"
                :rules="[isRequired]"
                @update:search-input="searchItems"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
        </v-col> 
        <v-col cols="12" md="3" class="pe-1">
            <v-text-field
                label="Quantity"
                v-model="line.quantity"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="d-flex">
            <v-autocomplete
                label="Unit"
                v-model="line.measure_unit_id"
                :rules="[isRequired]"
                :items="measureUnits"
                item-text="abbreviation"
                item-value="id"
                dense
                outlined
                hide-details
            >
            </v-autocomplete>
            <v-btn icon @click="handleDeleteLine">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric} from "./../../utils/validations"
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "GoodReceiptFormLine",
    props: {
       value: Object
    },
    data() {
        return {
           line: {},
        }
    },
    watch: {
        line: {
            handler(line) {
                this.$emit("input", {...line});
            },
            deep: true
        }
    },
    methods: {
        isRequired,
        isNumeric,
        ...mapActions({
            searchItems: "purchase/item/search"
        }),
        handleDeleteLine() {
            this.$emit("deleteLine")
        }
    },
    computed: {
        ...mapGetters({
            items: "purchase/item/list"
        }),
        selectedItem() {
            return this.items.find(e => e.id == this.line.item_id)
        },
        measureUnits() {
            if(!this.selectedItem) return [];
            let measureUnits = this.selectedItem.measure_units;            
            return Array.isArray(measureUnits) ? measureUnits : [];
        },
    },
    mounted() {
        if(this.value.item_id){
            this.line = { ...this.value }
        }
    }
}
</script>

<style>

</style>